import { BidderAdapter } from '@pubstack/common/src/adm/bidder-adapter'
import { PrebidConfig } from '@pubstack/common/src/prebidConfig'
import { AdmSiteConfig } from '@pubstack/common/src/siteConfig'
import { useAtomValue } from 'jotai'
import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { useBidderAdapters, usePrebidConfig, usePrebidSiteConfig } from '~/api/adm-api.hook'
import { useToast } from '~/components/Toast/useToasts'
import { configurationState } from '~/state'
import { PureAdmPrebidIntegrationPage } from './PureAdmPrebidIntegrationPage'

export const AdmPrebidIntegrationPage: React.FunctionComponent = () => {
  const { STATIC_ASSETS_CDN } = useAtomValue(configurationState)
  const toast = useToast()
  const navigate = useNavigate()
  const [currentPrebidConfig, setPrebidConfig] = useState<PrebidConfig>({ scopeId: '', apsAccountId: '', sites: [], siteConfigs: [] })
  const [bidderAdapters, setBidderAdapters] = useState<BidderAdapter[]>([])
  const { prebidConfig } = usePrebidConfig(null)
  const { prebidSiteConfig } = usePrebidSiteConfig(null)
  const { all: allBidderAdapters } = useBidderAdapters(null)

  const getCurrentPrebidConfig = async () => {
    const currentPrebidConfig = await prebidConfig.get()
    setPrebidConfig(currentPrebidConfig)
  }
  const getBidderAdapters = async () => {
    if (allBidderAdapters.loading) {
      allBidderAdapters.abort()
    }
    const usedBidders = await allBidderAdapters.get()
    setBidderAdapters(usedBidders)
  }

  const onSaveApsAccountId = async (apsAccountId: string) => {
    try {
      const res = await prebidConfig.putApsAccountId(apsAccountId)
      setPrebidConfig(res)
      toast.success(`The APS account id has been saved.`)
    } catch (_err) {
      toast.alert('An error occurred when trying to save the APS account id.')
    }
  }

  const onCreateSiteConfig = async (siteConfig: AdmSiteConfig) => {
    try {
      await prebidSiteConfig.put(siteConfig)
      await getCurrentPrebidConfig()
      toast.admSuccess(currentPrebidConfig.sites.find((site) => site.id === siteConfig.siteId)?.name ?? '', true, navigate)
    } catch (_err) {
      toast.alert(`An error occurred when trying to save the site configuration.`)
    }
  }

  useEffect(() => {
    /* oxlint-disable react/set-state-in-effect -- legitimate data load on mount (async fetch then setState) */
    getCurrentPrebidConfig()
    getBidderAdapters()
    /* oxlint-enable react/set-state-in-effect */
  }, [])

  return (
    <PureAdmPrebidIntegrationPage
      isLoading={prebidConfig.loading || prebidSiteConfig.loading}
      prebidConfig={currentPrebidConfig}
      onCreateSiteConfig={onCreateSiteConfig}
      onSaveApsAccountId={onSaveApsAccountId}
      baseCDNUrl={STATIC_ASSETS_CDN}
      bidderAdapters={bidderAdapters}
    />
  )
}
